import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { branch_helper } from "@/helpers/branch_helper";

export default function BranchesPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const title = "Our Branches";

  return {
    props: {
      meta: { title: createTitle(title) },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Contact us", href: getRoute("contact") },
              { label: title, href: getRoute("branches") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: { path: "page.branches.component.Header.title", placeholder: title },
            description: { path: "page.branches.component.Header.description" },
          },
        },
        { component: "BranchLookupPanel", props: { branches: branch_helper.fetch() } },
        {
          component: "BranchList",
          props: { branches: branch_helper.fetch() },
        },
      ],
    },
  };
}
